import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { Trans } from '@lingui/react/macro';
import type { ComponentProps, ReactNode } from 'react';

import { Button } from '@/components/buttons';
import { cn } from '@/lib/utils';

export type DialogFooterProps = ComponentProps<'div'> & {
  showCloseButton?: boolean;
  children?: ReactNode;
};

const DialogFooter = ({
  className,
  showCloseButton = false,
  children,
  ...props
}: DialogFooterProps) => {
  return (
    <div
      data-slot="dialog-footer"
      className={cn(
        'flex flex-row justify-between gap-2 [&>*:only-child]:ml-auto',
        '-mx-6 mt-4 -mb-10 rounded-b-xs px-6 py-5',
        'border-t border-gray-500 bg-primary',
        className,
      )}
      {...props}
    >
      {children}
      {showCloseButton && (
        <DialogPrimitive.Close
          render={
            <Button variant="secondary">
              <Trans>Close</Trans>
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DialogFooter;
